import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getIcon = (icon: IconProp) => <FontAwesomeIcon icon={icon} />;

export default {
  getIcon,
};
